const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C13.9891 4.5 15.8968 5.29018 17.3033 6.6967C18.7098 8.10322 19.5 10.0109 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12ZM18.375 12C18.375 8.47918 15.5208 5.625 12 5.625C8.4809 5.62913 5.62913 8.4809 5.625 12C5.625 15.5208 8.47918 18.375 12 18.375C15.5208 18.375 18.375 15.5208 18.375 12ZM12.75 15.75V10.5C12.75 10.0858 12.4142 9.75 12 9.75C11.5858 9.75 11.25 10.0858 11.25 10.5V15.75C11.25 16.1642 11.5858 16.5 12 16.5C12.4142 16.5 12.75 16.1642 12.75 15.75ZM12.285 8.955L12.15 9H12C11.8014 8.99724 11.6112 8.91955 11.4675 8.7825C11.4013 8.7096 11.348 8.62589 11.31 8.535C11.2716 8.44483 11.2512 8.34801 11.25 8.25C11.2454 8.02214 11.3446 7.80455 11.5197 7.65865C11.6948 7.51275 11.9267 7.45437 12.15 7.5L12.285 7.56L12.42 7.6275L12.5325 7.7175C12.6696 7.86123 12.7472 8.05142 12.75 8.25C12.7508 8.35306 12.7304 8.45518 12.69 8.55C12.652 8.64089 12.5987 8.7246 12.5325 8.7975L12.42 8.8875L12.285 8.955Z",
  fill: "#6B8FBC"
});

const SvgEquationCategory10 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationCategory10, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-category-10.3810be30.svg";
export { ForwardRef as ReactComponent };